import { render, staticRenderFns } from "./SaldosEnCuentas.vue?vue&type=template&id=a020b634"
import script from "./SaldosEnCuentas.vue?vue&type=script&lang=js"
export * from "./SaldosEnCuentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports